import React from 'react'
import { Modal } from '@scuf/common'
import AssetManagementTable from '../../../../AssetManagementTable'
import { ModalWrap, ModalTitle } from './scanner-firmware-modal.styles'

export const columns = [
  { field: 'key', translation: 'AssetManagementTable_osVersion', render: ({ value }) => <p>{value.toUpperCase()}</p> },
  { field: 'value', translation: 'AssetManagementTable_osVersionCount', render: null },
  { field: 'percentage', translation: 'AssetManagementTable_percentage', render: ({ value }) => <p>{value} %</p> }
]

const ScannerFirmwareModal = ({ data, t }) => (
  <ModalWrap>
    <ModalTitle>{t('ScannerFirmware_title')}</ModalTitle>
    <Modal.Content>
      <AssetManagementTable
        columns={columns}
        data={data}
        disableRowClick
        fileName={t('ScannerFirmware_title')}
      />
    </Modal.Content>
  </ModalWrap>
)

export default ScannerFirmwareModal
